import { IMerchantStatus, IPaymentAcceptanceParams } from '../interfaces';
import { t } from 'helpers/i18n';

const DEFAULT_PAGINATION = {
  page: 1,
  page_size: 50,
};

const DEFAULT_QUERY_PARAMS: IPaymentAcceptanceParams = {
  ...DEFAULT_PAGINATION,
};

const STATUSES: IMerchantStatus = {
  1: {
    code: 1,
    display: 'MerchantStatus.Initialize',
    name: t('MerchantStatus.Initialize'),
    color: '#259B24',
  },
  2: {
    code: 2,
    display: 'MerchantStatus.WaitingApprove',
    name: t('MerchantStatus.WaitingApprove'),
    color: '#C1051C',
  },
  3: {
    code: 3,
    display: 'MerchantStatus.Active',
    name: t('MerchantStatus.Active'),
    color: '#5F1665',
  },
  4: {
    code: 4,
    display: 'MerchantStatus.SaleReject',
    name: t('MerchantStatus.SaleReject'),
    color: '#259B24',
  },
  5: {
    code: 5,
    display: 'MerchantStatus.WaitingCompleteDocument',
    name: t('MerchantStatus.WaitingCompleteDocument'),
    color: '#C1051C',
  },
  6: {
    code: 6,
    display: 'MerchantStatus.WaitingUpdateContract',
    name: t('MerchantStatus.WaitingUpdateContract'),
    color: '#FF7E17',
  },
  7: {
    code: 7,
    display: 'MerchantStatus.Lock',
    name: t('MerchantStatus.Lock'),
    color: '#FF7E17',
  },
};

const SERVICE_STATUSES: { [key: string]: { [key: string]: string } } = {
  1: {
    name: 'Khởi tạo',
    color: '#259B24',
  },
  3: {
    name: 'Hoạt động',
    color: '#5F1665',
  },
  7: {
    name: 'Khóa',
    color: '#FF7E17',
  },
};

export default {
  DEFAULT_QUERY_PARAMS,
  STATUSES,
  SERVICE_STATUSES,
};
